export default __webpack_public_path__ + "static/media/innovation-metrics.f7d0149b.svg";